import { Modal } from "react-bootstrap";
import { CrossIcon } from "~/components/icons/cross";
import { DLSButton } from "~/components/shared/DLSButton";
import { DLSButtonV2 } from "~/components/shared/DLSButtonV2";
import * as styles from "./index.module.scss";

export const DLSModal = ({
  title = "",
  subTitle = "",
  children = null,
  onHide,
  primary = null,
  secondary = null,
  tertiary = null,
  show,
  closeButton = true,
  ...rest
}) => {
  const canShowFooter = primary || secondary || tertiary;
  const withChevron = tertiary?.Icon ? "" : "right";

  const generateModalButton = (buttonProps) => {
    return (
      <>
        {buttonProps.theme === "v2" ? (
          <DLSButtonV2 {...buttonProps} />
        ) : (
          <DLSButton {...buttonProps} />
        )}
      </>
    );
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      dialogClassName={styles.wrapper}
      data-testid="modal-dialog"
      className={styles.dialog}
      {...rest}
    >
      <Modal.Header className={styles.header}>
        {title && <h2 className={styles.title}>{title}</h2>}
        {subTitle && <p className={styles.subTitle}>{subTitle}</p>}
        {closeButton && (
          <button
            aria-label="Close modal"
            type="button"
            className={styles.close}
            onClick={onHide}
          >
            <CrossIcon />
          </button>
        )}
      </Modal.Header>
      <Modal.Body className={styles.body}>{children}</Modal.Body>
      {canShowFooter && (
        <Modal.Footer className={styles.footer}>
          <div className={styles.actionsRow}>
            {primary && generateModalButton({ ...primary, layout: "primary" })}
            {secondary &&
              generateModalButton({ ...secondary, layout: "secondary" })}
            {tertiary &&
              generateModalButton({
                ...tertiary,
                layout: "tertiary",
                withChevron,
              })}
          </div>
        </Modal.Footer>
      )}
    </Modal>
  );
};
